import { API_URL } from "../Config";
import { PageResult } from "../Pagination";

export interface IComplianceInvestigationLikelyCause {
  cilikelycauseid: string;
  cause: string;
  description: string;
  complianceinvestigationid: string;
}

export interface IComplianceInvestigatioLikelyCauseList extends PageResult {
  list: IComplianceInvestigationLikelyCause[];
}

export const GetComplianceInvestigationLikelyCausesFetchUrl = (
  complianceInvestigationId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  var params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  let url = `${API_URL}/Ci/listcilikelycauses?ci_id=${complianceInvestigationId}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/ci-likely-causes`;
  }

  return url;
};
